import type { FaireProductEntity } from "../../entity_types/product";

export const p_2787j24nz7: FaireProductEntity = {
  token: "p_2787j24nz7",
  type: "product",
  name: "New Mom Essential Matching Robe and Swaddle Set with Headband",
  brandToken: "b_uchz249maq",
  brandName: "Willie J’s: The Easy PJ’s",
  imageUrl:
    "https://cdn.faire.com/fastly/2e457074503383b6b0423f2c4cb0ddeae2f825072603114f0b46c17f33ffcd22.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aa0dc999798d15d0d41a7dd2fea7d982c55298383ee7db03382976b0e1770a20.jpeg",
    "https://cdn.faire.com/fastly/9c32115a195e3cd20b64eee2db0e3854c8a0d62e85350af3369e27a01d9b5c92.jpeg",
    "https://cdn.faire.com/fastly/f3fad8dd5d4b05fe8df12b60d1e550d918ae4ac017f5ff449f3165b2c3b726ba.png",
    "https://cdn.faire.com/fastly/3d38f6d8f15a603785f097239605d38e996f1f55970a69de74f3cfac56cc3ce6.jpeg",
    "https://cdn.faire.com/fastly/57b6f37356d296305e4783c76550075a72b67ef9981b1d1f513dd12e8d8d6a5e.jpeg",
  ],
  priceDollars: 22,
  description:
    "\nThis set is designed to bring comfort and confidence to your first days with your new baby. The soft, lightweight, and stretchy fabric will make you feel so relaxed and assured, while the unique floral prints add a stylish and cute touch. Our robe-swaddle set is perfect for creating photo memories and is machine washable with cold water and like colors. It's the perfect matching outfit for you and your baby that will help you be ready for your first visitors. Put it in your birth bag to be fully prepared for your hospital labor and delivery essentials.\n\nThese colorful robes let  moms and their new baby match in style and comfort.",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:20.797Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
